export const getMaxTermInLoanCalculator = (loanCalculator) =>
  loanCalculator.reduce(
    (max, loanCalculatorItem) =>
      loanCalculatorItem.payload.loan_calculator.term.period > max
        ? loanCalculatorItem.payload.loan_calculator.term.period
        : max,
    loanCalculator[0].payload.loan_calculator.term.period
  );
